/*
 * Copyright (c) 2019.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {FeatureType} from './FeatureType';
import {FeatureGroup} from './FeatureGroup';
import {Channel} from './Channel';
import {FeatureValue} from './FeatureValue';
import {Unit} from './Unit';
import {FeatureUnitRelation} from './FeatureUnitRelation';


export interface Feature {
  id: number;
  header: string;
  icon?: string;
  code?: string|number;
  enabled: boolean;
  isFilter: boolean;
  isInteger: boolean;
  required?: boolean;
  gold?: boolean;
  pos?: number;
  featureTypeId?: number;
  featureGroupId?: number;
  featureType?: FeatureType;
  featureGroup?: FeatureGroup;
  channels?: Channel[];
  values?: FeatureValue[];
  units?: Unit[];
  featureUnitRelation?: FeatureUnitRelation[];
  deleted?: boolean;
}
